export default __webpack_public_path__ + "static/media/section-5.7648c4e5.png";